<template>
  <div :class="['emd-form-group', `js${name}group`]">
    <label class="emd-checkbox" :for="name">
      {{title}}
      <input
        class="emd-checkbox__input"
        type="checkbox"
        :id="name"
        :name="name"
        :checked="value"
        @input="onInput"
        @change="handleInput"
      />
      <div class="emd-checkbox__area"></div>
    </label>
    <div :class="['emd-input-helper', `js${name}helper`]"></div>
  </div>
</template>
<script>
export default {
  name: 'EmdInputBoolean',
  props: ['required', 'name', 'value', 'default', 'onInput', 'title'],
  methods: {
    handleInput (event) {
      this.$emit('input', event.target.checked)
    }
  }
}
</script>
<style scoped>
</style>
